import { forwardRef } from 'react'
import { Slide } from '@mui/material'

const KrowTransition = forwardRef((properties, ref) => (
  <Slide direction="down" ref={ref} {...properties} />
))

export default KrowTransition
